import {
  createContext,
  FunctionComponent,
  ReactElement,
  useMemo,
  useState,
} from "react";
import { useMutation, useQuery } from "@tanstack/react-query";

import Api from "src/Config";

export const AddRadarRuleContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AddRadarRuleProvider: FunctionComponent<Props> = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState({
    label: "",
    value: "",
  });
  const [selectedRuleAttribute, setSelectedRuleAttribute] = useState({
    label: "",
    value: "",
    description: "",
  });
  const [ruleAttributes, setRuleAttributes] = useState([
    { label: "", value: "" },
  ]);
  const [ruleSets, setRuleSets] = useState([{ label: "", value: "" }]);
  const [formType, setFormType] = useState(null);
  const [entity, setEntity] = useState(null);
  const [selectedRuleSet, setSelectedRuleSet] = useState({
    label: "",
    value: "",
  });
  const [ruleValue, setRuleValue] = useState("");
  const [score, setScore] = useState<any>("");
  const [description, setDescription] = useState("");

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["rule_attribute", selectedCategory.value],
    enabled: !!selectedCategory.value,
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(
        `onboarding/rules/attributes?rule_type=${selectedCategory.value}`,
      );

      return data;
    },
  });

  const {
    mutateAsync,
    data: ruleData,
    isPending: pendingRule,
    error: errorRule,
  } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("onboarding/rules", payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const handleSelectCategory = (selected: any) => {
    setSelectedCategory({ label: selected.label, value: selected.value });
    setSelectedRuleAttribute({ label: "", value: "", description: "" });
    setSelectedRuleSet({ label: "", value: "" });
    setScore("");
    setDescription("");
  };

  const handleSelectAttribute = (selected: any) => {
    const ruleSets = selected?.sets?.map((rule: any) => ({
      // label: rule.replace(/is_/gi, " "),
      label: rule.label,
      value: rule.value,
      description: rule.description,
    }));
    setSelectedRuleAttribute({
      label: selected.label,
      value: selected.value,
      description: selected.description,
    });
    setRuleSets(ruleSets);
    setFormType(selected.type);
    setEntity(selected.entity);
    setSelectedRuleSet({ label: "", value: "" });
    setRuleValue("");
    setScore("");
  };

  const handleSelectRuleSet = (selected: any) => {
    // const
    setSelectedRuleSet({
      // label: selected.value.replace(/is_/g, ""),
      label: selected.label,
      value: selected.value,
    });
  };

  const handleToggleCondition = (value: any) => {
    setRuleValue(value);
  };

  const handleChangeValue = (e: any) => {
    // const regEx = /^[0-9]*$/;
    const inputValue = e.target.value;

    // if (regEx.test(inputValue)) {
    setRuleValue(inputValue);
    // }
  };

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      handleSelectCategory,
      setRuleAttributes,
      ruleAttributes,
      selectedCategory,
      handleSelectAttribute,
      selectedRuleAttribute,
      ruleSets,
      formType,
      entity,
      handleSelectRuleSet,
      selectedRuleSet,
      ruleValue,
      handleToggleCondition,
      handleChangeValue,
      mutateAsync,
      ruleData,
      pendingRule,
      errorRule,
      error,
      setSelectedCategory,
      setSelectedRuleAttribute,
      setRuleSets,
      setSelectedRuleSet,
      setRuleValue,
      score,
      setScore,
      description,
      setDescription,
    }),
    [
      isLoading,
      data,
      error,
      isFetching,
      handleSelectCategory,
      ruleAttributes,
      setRuleAttributes,
      selectedCategory,
      handleSelectAttribute,
      selectedRuleAttribute,
      ruleSets,
      formType,
      entity,
      handleSelectRuleSet,
      selectedRuleSet,
      ruleValue,
      handleToggleCondition,
      handleChangeValue,
      mutateAsync,
      ruleData,
      pendingRule,
      errorRule,
      setSelectedCategory,
      setSelectedRuleAttribute,
      setRuleSets,
      setSelectedRuleSet,
      setRuleValue,
      score,
      setScore,
      description,
      setDescription,
    ],
  );
  return (
    <AddRadarRuleContext.Provider value={contextValue}>
      {children}
    </AddRadarRuleContext.Provider>
  );
};

export default AddRadarRuleProvider;
